import {useGTMDispatch} from '../analytics/react-gtm-hook/index'

export const useGenerateLead = () => {
  const sendDataToGTM = useGTMDispatch()
  const sendFormData = (data) => {
    const {form_id, form_name, form_status, form_type} = data
    setTimeout(() => {
      try {
        sendDataToGTM({
          event: 'generate_lead',
          ecommerce: {
            form_id,
            form_name,
            form_status,
            form_type
          },
        })
      } catch (error) {
        console.error('useGenerateLead error: ' + error);
      }
    })
  }
  return sendFormData
}
